import { Outlet } from 'react-router-dom';
import { ReactElement } from 'react';
import Layout from 'app/molecules/Layout/dashboard';
import { AbilityContext, ability } from 'app/atoms';
import UserPermission from 'app/modules/UserPermission';
import Auth from 'app/modules/Auth/Auth';
import { VouchersParsingProvider } from 'app/modules/Trip/contexts/VouchersParsingContent';

const Pages = (): ReactElement => {
  return (
    <Auth>
      <UserPermission>
        <AbilityContext.Provider value={ability}>
          <VouchersParsingProvider>
            <Layout>
              <Outlet />
            </Layout>
          </VouchersParsingProvider>
        </AbilityContext.Provider>
      </UserPermission>
    </Auth>
  );
};

export default Pages;
